const config = {
    API_URL: process.env.REACT_APP_API_URL,
    DOMAIN_URL: process.env.REACT_APP_DOMAIN_URL || "https://www.salestrackify.com",
};

export default config;
